import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../../app/store";
import {LoginUser} from "../../../services/UsersService";

interface AnonymizeLoginUserModalState {
  isOpened: boolean;
  loginUser: LoginUser | null;
  isEmailChecked: boolean;
}

const initialState: AnonymizeLoginUserModalState = {
  isOpened: false,
  loginUser: null,
  isEmailChecked: false
};

export const AnonymizeLoginUserModalSlice = createSlice({
  name: "AnonymizeLoginUserModal",
  initialState,
  reducers: {
    close: () => initialState,
    open: (state, action: PayloadAction<LoginUser>) => {
      state.isOpened = true;
      state.loginUser = action.payload;
    },
    setEmailChecked: (state, action: PayloadAction<boolean>) => {
      state.isEmailChecked = action.payload;
    }
  }
});

export const anonymizeLoginUserModalState = (state: RootState): AnonymizeLoginUserModalState => state.anonymizeLoginUserModal;

export default AnonymizeLoginUserModalSlice.reducer;

export const {close, open, setEmailChecked} = AnonymizeLoginUserModalSlice.actions;
